import React from 'react';
import isNil from 'lodash/isNil';
import classnames from 'classnames';

import style from './RightContent.module.scss';
import '@components/mixins/mixin.scss';

import { ClickOutsideAlerter } from '@components/ClickOutsideAlerter';
import { Icon, IconType } from '@components/Icon';

export interface RightContentProps {
    onCloseClick(): void;
}

interface Props extends RightContentProps {
    title: string;
    children: React.ReactNode;
    onWheel(e: React.WheelEvent): void;
    onScroll(): void;
    onClickOutsideRightContent?(): void;
}

export function RightContent({ title, children, onWheel, onScroll, onClickOutsideRightContent, onCloseClick }: Props) {
    const noContent = isNil(children);

    return (
        <ClickOutsideAlerter
            inheritSize
            onClickOutside={onClickOutsideRightContent}
        >
            <div
                className={classnames([style.root, noContent && style.root_noContent])}
                onWheel={onWheel}
                onScroll={onScroll}
            >
                {!noContent && (
                    <React.Fragment>
                        <div className={style.title}>{title}</div>
                        <div className={style.content}>{children}</div>
                        <div
                            className={classnames(['closeIconWrapper', style.closeIconWrapper])}
                            onClick={onCloseClick}
                        >
                            <Icon type={IconType.CROSS} />
                        </div>
                    </React.Fragment>
                )}
            </div>
        </ClickOutsideAlerter>
    );
}
